var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{class:_vm.selectClass,attrs:{"id":_vm.id,"options":_vm.options,"placeholder":_vm.placeholder,"value":_vm.value,"reduce":(method) => method.value},on:{"input":(method) => _vm.$emit('input', method)}})
}
var staticRenderFns = []

export { render, staticRenderFns }